// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__OsNMr","form":"styles_form__1kEUV"};